/* eslint-disable camelcase */
import * as React from 'react';
import { navigate } from 'gatsby';
import { Box } from '@mui/material';
import { Listbox } from '@headlessui/react';
import { languages, setStorageLng } from '@/data/languages';
import { linkResolver } from '../../utils/linkResolver';

type Lang = {
  id: string;
  type: string;
  lang: string;
  uid: string;
  link_type: 'Document';
  tags: string[];
};

type LanguageSwitcherProps = {
  lang: string;
  altLangs: Lang[];
};

const WorldIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.03601 5.24402C9.15601 5.12402 9.15601 4.93202 9.03601 4.82402L8.22001 4.00802C8.10001 3.88802 7.92001 3.88802 7.80001 4.00802C7.68001 4.12802 7.68001 4.32002 7.80001 4.42802L8.61601 5.24402C8.73601 5.36402 8.91601 5.36402 9.03601 5.24402ZM12.84 5.316H13.2C13.308 5.316 13.392 5.304 13.392 5.196C13.392 5.088 13.308 5.076 13.2 5.076H12.84C12.732 5.076 12.648 5.088 12.648 5.196C12.648 5.304 12.732 5.316 12.84 5.316ZM14.016 6.69599C14.124 6.69599 14.244 6.59999 14.244 6.49199V5.98799C14.244 5.87999 14.124 5.78399 14.016 5.78399C13.908 5.78399 13.788 5.87999 13.788 5.98799V6.49199C13.788 6.59999 13.908 6.69599 14.016 6.69599ZM6.21599 11.724C5.79599 11.724 5.54399 12.06 5.54399 12.48V15.324C5.54399 15.744 5.79599 16.068 6.21599 16.068H6.68399V18.948C6.68399 19.356 7.07999 19.68 7.48799 19.68C7.89599 19.68 8.29199 19.356 8.29199 18.948V17.22H8.26799C8.68799 17.22 8.98799 16.992 8.98799 16.572V16.08H9.20399C9.62399 16.08 9.89999 15.744 9.89999 15.336V14.364C9.89999 14.352 9.91199 14.352 9.89999 14.34L7.31999 11.724H6.21599ZM12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 21.6C6.696 21.6 2.4 17.304 2.4 12C2.4 11.112 2.532 10.248 2.76 9.432H2.796V10.212C2.796 10.548 3.096 10.812 3.432 10.812C3.492 10.812 3.552 10.8 3.612 10.788L4.872 12.048C4.992 12.18 5.208 12.18 5.328 12.048C5.448 11.928 5.46 11.724 5.328 11.592L4.104 10.308C4.104 10.272 4.164 10.248 4.164 10.212V10.02C4.164 9.756 4.308 9.66 4.572 9.432H5.328C5.472 9.432 5.604 9.42 5.712 9.348C5.724 9.336 5.736 9.348 5.748 9.336C5.772 9.312 5.796 9.3 5.82 9.288C5.832 9.276 5.844 9.276 5.856 9.264L5.88 9.24L8.46 6.66C8.748 6.372 8.748 5.904 8.46 5.628C8.184 5.34 7.716 5.4 7.428 5.676L6.936 6.228H6V5.46C6 5.448 6.084 5.544 6.084 5.316H7.128C7.332 5.316 7.488 5.172 7.488 4.968C7.488 4.764 7.332 4.62 7.128 4.62H5.856C7.524 3.24 9.66 2.4 12 2.4C14.34 2.4 16.476 3.24 18.144 4.632H16.248L16.236 4.584C16.164 4.584 16.092 4.584 16.032 4.632L15.18 5.472C15.072 5.58 15.072 5.748 15.18 5.844C15.288 5.952 15.456 5.952 15.564 5.844L16.236 5.124L16.248 5.088H16.656C16.656 5.316 16.536 5.244 16.536 5.28V5.4C16.536 5.748 16.296 6 15.948 6H15.336C15.036 6 14.712 6.336 14.712 6.648V6.924H14.568C14.376 6.924 14.244 7.02 14.244 7.212C14.244 7.308 14.244 7.608 14.244 7.608H13.86C13.584 7.608 13.368 7.788 13.368 8.064C13.368 8.328 13.584 8.484 13.86 8.484C13.98 8.484 14.088 8.532 14.172 8.292L14.244 8.304L15.036 7.596H15.312L15.948 8.196C15.996 8.244 16.08 8.232 16.14 8.184C16.188 8.136 16.188 7.992 16.14 7.944L15.6 7.38H15.984L16.128 7.572C16.428 7.872 16.908 7.848 17.196 7.548L17.34 7.38H18C18.024 7.38 18.132 7.464 18.132 7.464V7.86C18.132 7.86 18.06 7.848 18.048 7.848H17.46C17.268 7.848 17.124 8.004 17.124 8.196C17.124 8.388 17.28 8.544 17.46 8.544H18.048C18.06 8.544 18.132 8.532 18.132 8.532V8.772C17.904 9.108 17.736 9.456 17.388 9.456H15.852C15.852 9.456 15.852 9.444 15.84 9.444L15.144 8.748C14.844 8.448 14.376 8.448 14.076 8.748L13.38 9.444C13.38 9.444 13.38 9.456 13.368 9.456H12.96C12.54 9.456 12.156 9.792 12.156 10.212V11.712C12.156 12.132 12.54 12.444 12.96 12.444H14.424C14.976 12.672 15.36 13.02 15.588 13.572V16.308C15.588 16.728 15.864 17.028 16.284 17.028H17.46C17.88 17.028 18.108 16.728 18.108 16.308V13.668L19.56 12.264L19.608 12.24L19.632 12.228H19.68C19.8 12.096 19.92 11.916 19.92 11.724V10.188C19.92 9.888 19.656 9.66 19.416 9.432H20.112C20.136 9.888 20.46 10.116 20.868 10.116H21.384C21.54 10.728 21.6 11.352 21.6 12C21.6 17.304 17.304 21.6 12 21.6ZM19.392 14.82C19.224 14.82 19.044 14.952 19.044 15.12V16.044C19.044 16.212 19.224 16.344 19.392 16.344C19.56 16.344 19.74 16.212 19.74 16.044V15.12C19.74 14.952 19.56 14.82 19.392 14.82ZM12.6 4.17599C12.6 3.76799 12.264 3.49199 11.856 3.49199H10.968C10.56 3.49199 10.284 3.79199 10.284 4.19999C10.284 4.25999 10.128 4.27199 10.356 4.31999V5.08799C10.356 5.32799 10.464 5.51999 10.704 5.51999C10.944 5.51999 11.052 5.32799 11.052 5.08799V4.85999H11.868C12.264 4.85999 12.6 4.58399 12.6 4.17599Z"
      fill="#CECCCC"
    />
    <mask
      id="mask0_1340_17723"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.03601 5.24402C9.15601 5.12402 9.15601 4.93202 9.03601 4.82402L8.22001 4.00802C8.10001 3.88802 7.92001 3.88802 7.80001 4.00802C7.68001 4.12802 7.68001 4.32002 7.80001 4.42802L8.61601 5.24402C8.73601 5.36402 8.91601 5.36402 9.03601 5.24402ZM12.84 5.316H13.2C13.308 5.316 13.392 5.304 13.392 5.196C13.392 5.088 13.308 5.076 13.2 5.076H12.84C12.732 5.076 12.648 5.088 12.648 5.196C12.648 5.304 12.732 5.316 12.84 5.316ZM14.016 6.69599C14.124 6.69599 14.244 6.59999 14.244 6.49199V5.98799C14.244 5.87999 14.124 5.78399 14.016 5.78399C13.908 5.78399 13.788 5.87999 13.788 5.98799V6.49199C13.788 6.59999 13.908 6.69599 14.016 6.69599ZM6.21599 11.724C5.79599 11.724 5.54399 12.06 5.54399 12.48V15.324C5.54399 15.744 5.79599 16.068 6.21599 16.068H6.68399V18.948C6.68399 19.356 7.07999 19.68 7.48799 19.68C7.89599 19.68 8.29199 19.356 8.29199 18.948V17.22H8.26799C8.68799 17.22 8.98799 16.992 8.98799 16.572V16.08H9.20399C9.62399 16.08 9.89999 15.744 9.89999 15.336V14.364C9.89999 14.352 9.91199 14.352 9.89999 14.34L7.31999 11.724H6.21599ZM12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 21.6C6.696 21.6 2.4 17.304 2.4 12C2.4 11.112 2.532 10.248 2.76 9.432H2.796V10.212C2.796 10.548 3.096 10.812 3.432 10.812C3.492 10.812 3.552 10.8 3.612 10.788L4.872 12.048C4.992 12.18 5.208 12.18 5.328 12.048C5.448 11.928 5.46 11.724 5.328 11.592L4.104 10.308C4.104 10.272 4.164 10.248 4.164 10.212V10.02C4.164 9.756 4.308 9.66 4.572 9.432H5.328C5.472 9.432 5.604 9.42 5.712 9.348C5.724 9.336 5.736 9.348 5.748 9.336C5.772 9.312 5.796 9.3 5.82 9.288C5.832 9.276 5.844 9.276 5.856 9.264L5.88 9.24L8.46 6.66C8.748 6.372 8.748 5.904 8.46 5.628C8.184 5.34 7.716 5.4 7.428 5.676L6.936 6.228H6V5.46C6 5.448 6.084 5.544 6.084 5.316H7.128C7.332 5.316 7.488 5.172 7.488 4.968C7.488 4.764 7.332 4.62 7.128 4.62H5.856C7.524 3.24 9.66 2.4 12 2.4C14.34 2.4 16.476 3.24 18.144 4.632H16.248L16.236 4.584C16.164 4.584 16.092 4.584 16.032 4.632L15.18 5.472C15.072 5.58 15.072 5.748 15.18 5.844C15.288 5.952 15.456 5.952 15.564 5.844L16.236 5.124L16.248 5.088H16.656C16.656 5.316 16.536 5.244 16.536 5.28V5.4C16.536 5.748 16.296 6 15.948 6H15.336C15.036 6 14.712 6.336 14.712 6.648V6.924H14.568C14.376 6.924 14.244 7.02 14.244 7.212C14.244 7.308 14.244 7.608 14.244 7.608H13.86C13.584 7.608 13.368 7.788 13.368 8.064C13.368 8.328 13.584 8.484 13.86 8.484C13.98 8.484 14.088 8.532 14.172 8.292L14.244 8.304L15.036 7.596H15.312L15.948 8.196C15.996 8.244 16.08 8.232 16.14 8.184C16.188 8.136 16.188 7.992 16.14 7.944L15.6 7.38H15.984L16.128 7.572C16.428 7.872 16.908 7.848 17.196 7.548L17.34 7.38H18C18.024 7.38 18.132 7.464 18.132 7.464V7.86C18.132 7.86 18.06 7.848 18.048 7.848H17.46C17.268 7.848 17.124 8.004 17.124 8.196C17.124 8.388 17.28 8.544 17.46 8.544H18.048C18.06 8.544 18.132 8.532 18.132 8.532V8.772C17.904 9.108 17.736 9.456 17.388 9.456H15.852C15.852 9.456 15.852 9.444 15.84 9.444L15.144 8.748C14.844 8.448 14.376 8.448 14.076 8.748L13.38 9.444C13.38 9.444 13.38 9.456 13.368 9.456H12.96C12.54 9.456 12.156 9.792 12.156 10.212V11.712C12.156 12.132 12.54 12.444 12.96 12.444H14.424C14.976 12.672 15.36 13.02 15.588 13.572V16.308C15.588 16.728 15.864 17.028 16.284 17.028H17.46C17.88 17.028 18.108 16.728 18.108 16.308V13.668L19.56 12.264L19.608 12.24L19.632 12.228H19.68C19.8 12.096 19.92 11.916 19.92 11.724V10.188C19.92 9.888 19.656 9.66 19.416 9.432H20.112C20.136 9.888 20.46 10.116 20.868 10.116H21.384C21.54 10.728 21.6 11.352 21.6 12C21.6 17.304 17.304 21.6 12 21.6ZM19.392 14.82C19.224 14.82 19.044 14.952 19.044 15.12V16.044C19.044 16.212 19.224 16.344 19.392 16.344C19.56 16.344 19.74 16.212 19.74 16.044V15.12C19.74 14.952 19.56 14.82 19.392 14.82ZM12.6 4.17599C12.6 3.76799 12.264 3.49199 11.856 3.49199H10.968C10.56 3.49199 10.284 3.79199 10.284 4.19999C10.284 4.25999 10.128 4.27199 10.356 4.31999V5.08799C10.356 5.32799 10.464 5.51999 10.704 5.51999C10.944 5.51999 11.052 5.32799 11.052 5.08799V4.85999H11.868C12.264 4.85999 12.6 4.58399 12.6 4.17599Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1340_17723)" />
  </svg>
);

export const LanguageSwitcher = ({
  lang,
  altLangs,
}: LanguageSwitcherProps): JSX.Element => {
  // Trigger select change event
  const handleLangChange = (event: string) => {
    const lng = event.slice(1, -1);
    setStorageLng(lng);
    navigate(event);
  };

  return (
    <Box
      sx={{
        display: `flex`,
        alignItems: `center`,
        justifyContent: { xs: `start`, md: `end` },
        gap: 1,
        width: 1,
        zIndex: 2,
        mb: 2,
      }}
    >
      <WorldIcon />
      <Listbox value={lang} onChange={handleLangChange}>
        <Box
          sx={{
            width: 1,
            maxWidth: 256,
            position: `relative`,
          }}
        >
          <Box
            component={Listbox.Button}
            sx={{
              background: `none`,
              border: `none`,
              width: 1,
              height: 1,
              px: 0,
              borderRadius: `12px`,
            }}
          >
            {({ open }: any) => (
              <Box
                component="span"
                sx={{
                  border: open ? `1px solid #858080` : `1px solid #E7E6E6`,
                  height: 1,
                  width: 1,
                  px: 2,
                  py: 1.5,
                  backgroundImage: `url("/down-chevron.svg")`,
                  backgroundRepeat: `no-repeat`,
                  backgroundPosition: `right 8px center`,
                  borderRadius: `12px`,
                  backgroundColor: `#ffffff`,
                  textAlign: `left`,
                  cursor: `pointer`,
                  fontSize: `16px`,
                  lineHeight: `24px`,
                  letterSpacing: `-0.04px`,
                  fontWeight: 400,
                  color: `#858080`,
                  display: `block`,
                }}
              >
                {languages[lang]}
              </Box>
            )}
          </Box>
          <Box
            component={Listbox.Options}
            sx={{
              position: `absolute`,
              bottom: `calc(100% - 26px)`,
              listStyleType: `none`,
              width: 1,
              maxWidth: 256,
              padding: 0,
              borderLeft: `1px solid #858080`,
              borderRight: `1px solid #858080`,
              borderTop: `1px solid #858080`,
              borderTopLeftRadius: `12px`,
              borderTopRightRadius: `12px`,
              overflow: `hidden`,
              zIndex: -1,
            }}
          >
            {altLangs.map((altLang, i) => (
              <Listbox.Option key={altLang.lang} value={linkResolver(altLang)}>
                {() => (
                  <Box sx={{}}>
                    <Box
                      sx={{
                        cursor: `pointer`,
                        width: 1,
                        maxWidth: 256,
                        textAlign: `left`,
                        px: 2,
                        pt: 1.5,
                        pb: i === altLangs.length - 1 ? 2.5 : 1.5,
                        color: `#858080`,
                        fontSize: `16px`,
                        lineHeight: `24px`,
                        letterSpacing: `-0.04px`,
                        fontWeight: 400,
                        zIndex: `-1`,
                        backgroundColor: `#ffffff`,
                        '&:hover': {
                          backgroundColor: `#E7E6E6`,
                        },
                      }}
                    >
                      {languages[altLang.lang]}
                    </Box>
                  </Box>
                )}
              </Listbox.Option>
            ))}
          </Box>
        </Box>
      </Listbox>
    </Box>
  );
};
